export default {
  messages: {
    en: {
      image: {
        alt: 'Entrepreneur image {index}',
      },
      thumb: {
        alt: 'Entrepreneur image {index} thumbnail',
      },
    },
  },
}
